import { css } from "styled-components";

import { breakpoints } from "./breakpoints";
import { redundantCssFromKebab } from "./redundant-css";
import { fontSizes } from "./textSize";

const baseHeadingStyle = css`
    ${redundantCssFromKebab("font-weight", "500")}
    ${redundantCssFromKebab("margin-block-end", "0.5rem")}
    ${redundantCssFromKebab("margin-block-start", "0")}
`;

export const h1: ReturnType<typeof css> = css`
    ${baseHeadingStyle}
    ${redundantCssFromKebab("font-size", `${fontSizes.xl}`)}
    ${redundantCssFromKebab("line-height", "1.25")}
    @media (min-width: ${breakpoints.md}px) {
        ${redundantCssFromKebab("font-size", "2.75rem")}
        ${redundantCssFromKebab("line-height", "1.18181818")}
    }
    @media (min-width: ${breakpoints.lg}px) {
        ${redundantCssFromKebab("font-size", "3rem")}
        ${redundantCssFromKebab("line-height", "1.25")}
    }
`;

export const h2: ReturnType<typeof css> = css`
    ${baseHeadingStyle}
    ${redundantCssFromKebab("font-size", `${fontSizes.lg}`)}
    ${redundantCssFromKebab("line-height", "1.33333333")}
    @media (min-width: ${breakpoints.md}px) {
        ${redundantCssFromKebab("font-size", `${fontSizes.xxl}`)}
        ${redundantCssFromKebab("line-height", "1.33333333")}
    }
`;

export const h3: ReturnType<typeof css> = css`
    ${baseHeadingStyle}
    ${redundantCssFromKebab("font-size", `${fontSizes.md}`)}
    ${redundantCssFromKebab("line-height", "1.2")}
    @media (min-width: ${breakpoints.md}px) {
        ${redundantCssFromKebab("font-size", `${fontSizes.lg}`)}
        ${redundantCssFromKebab("line-height", "1.33333333")}
    }
`;

export const h4: ReturnType<typeof css> = css`
    ${baseHeadingStyle}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("line-height", "1.25")}
    @media (min-width: ${breakpoints.md}px) {
        ${redundantCssFromKebab("font-size", `${fontSizes.md}`)}
        ${redundantCssFromKebab("line-height", "1.2")}
    }
`;

export const h5: ReturnType<typeof css> = css`
    ${baseHeadingStyle}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("line-height", "1.25")}
    ${redundantCssFromKebab("text-transform", "uppercase")}
`;

export const h6: ReturnType<typeof css> = css`
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("font-weight", "500")}
    ${redundantCssFromKebab("line-height", "1.2")}
    ${redundantCssFromKebab("margin-block-end", "0.5rem")}
    ${redundantCssFromKebab("margin-block-start", "0")}
`;
